module.exports = __webpack_public_path__ + "img/word1.146904b7.png";